"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Button_1 = require("./Button");
const store_1 = require("./store");
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const floor_view_scss_1 = __importDefault(require("./styles/floor-view.scss"));
function FloorView({}) {
    const selected = react_redux_1.useSelector((state) => state.floor.selected);
    const stages = react_redux_1.useSelector((state) => state.floor.stages);
    return (React.createElement(React.Fragment, null,
        stages.map((map, i) => (React.createElement(FloorItem, { key: i, stage: i + 1, map: map, selected: i + 1 === selected }))),
        React.createElement(AppendButton, { stage: stages.length + 1 })));
}
exports.FloorView = FloorView;
function FloorItem({ map, stage, selected }) {
    const dispatch = react_redux_1.useDispatch();
    const onClick = React.useCallback(() => {
        dispatch(store_1.actions.setFloor(stage));
        dispatch(store_1.actions.setEditorMode(store_1.EditorMode.Map));
    }, [stage]);
    return (React.createElement("button", { className: classnames_1.default(floor_view_scss_1.default.item, selected && floor_view_scss_1.default.selected, flex_scss_1.default.vertical), onClick: onClick },
        React.createElement("span", { className: floor_view_scss_1.default.number }, stage),
        React.createElement("div", { className: floor_view_scss_1.default.image, style: { backgroundImage: `url(${map.thumbnailUrl})` } })));
}
exports.FloorItem = FloorItem;
function AppendButton({ stage }) {
    const onClick = React.useCallback(() => { }, []);
    return (React.createElement("button", { className: classnames_1.default(floor_view_scss_1.default.item, flex_scss_1.default.vertical), onClick: onClick },
        React.createElement("span", { className: floor_view_scss_1.default.number }, stage),
        React.createElement("div", { className: floor_view_scss_1.default.image, style: { backgroundColor: 'green' } }),
        React.createElement(Button_1.Icon, { name: "add", className: floor_view_scss_1.default.append })));
}
